export class User {
  userName: string;
  firstname: string;
  lastname: string;
  constructor(userName: string, firstname: string, lastname :string) {
    this.userName = userName;
    this.firstname = firstname;
    this.lastname = lastname;
  }
}



// WEBPACK FOOTER //
// ./src/components/app/infrastructure/models/user.ts